<template>
  <div class="flex items-center lg:pt-2">
    <button
      class="flex items-center justify-center w-8 h-8 transition duration-200 border rounded-full shadow border-opacity-30 border-brand-500 hover:border-opacity-50 active:bg-brand-500 active:text-white active:border-opacity-100"
      @click="action('min')"
    >
      <p class="-mt-1 text-2xl">
        -
      </p>
    </button>
    <div class="w-32 text-sm tracking-wider text-center uppercase">
      <transition name="rooms">
        <p
          v-if="value > 0"
          class="text-base"
        >
          {{ value }}+
        </p>
      </transition>
      <p :class="value > 0 ? 'text-gray-400' : ''">
        {{ locales[lang].rooms }}
      </p>
    </div>
    <button
      class="flex items-center justify-center w-8 h-8 transition duration-200 border rounded-full shadow border-opacity-30 border-brand-500 hover:border-opacity-50 active:bg-brand-500 active:text-white active:border-opacity-100"
      @click="action('plus')"
    >
      <p class="text-2xl">
        +
      </p>
    </button>
  </div>
</template>

<script>
import bus from "../js/bus.js";

export default {
  props: ["lang", "locales"],
  data() {
    return {
      value: false,
    };
  },
  mounted() {
    bus.$on("updateData", (item) => {
      if (item.id === "rooms" && item.data) {
        this.value = item.data;
      } else if (item.id === "rooms" && !item.data) {
        this.value = false;
      }
    });
  },
  methods: {
    action(arg) {
      if (arg === "min") {
        if (this.value > 1) {
          this.value -= 1;
        } else {
          this.value = false;
        }
      }

      if (arg === "plus") {
        if (this.value < 100) {
          this.value += 1;
        }
      }
      this.edited();
    },
    edited() {
      bus.$emit("setData", {
        id: "rooms",
        data: this.value,
      });
    },
  },
};
</script>

<style>
.rooms-enter-active,
.rooms-leave-active {
  @apply transform transition-all duration-500 h-6;
}

.rooms-enter,
.rooms-leave-to {
  @apply opacity-0 -translate-y-10 h-0;
}
</style>
